import { Box, Text, Image, Avatar, Flex, Select, Badge, Divider, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, useDisclosure, Grid, Tooltip } from '@chakra-ui/react';
import MyDiv from './leaveBalanceCard.style';
import { ChevronDownIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from 'react';
import LeaveBalanceModal from '../LeaveBalanceModal';
import CopyIcon from "../../../../assets/images/CopyIcon.svg";
import DepartmentFrame from "../../../../assets/images/DepartmentFrame.svg";
import BranchFrame from "../../../../assets/images/BranchFrame.svg";
import EmailFrame from "../../../../assets/images/EmailFrame.svg";
import PhoneFrame from "../../../../assets/images/PhoneFrame.svg";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { CustomToast } from '../../../../components';
import BackgroundProfileImg from "../../../../assets/images/CardBackgroundImg.jpg";
import { baseUrl, useFetch } from '../../../../hooks/useFetch';
import { EmployeeLeaveData, Iprops } from './modal';
import DummyPerson from "../../../../assets/images/DummyPerson.svg"
import { useAuth } from '../../../../hooks/useAuth';

const LeaveBalanceCard = (props: Iprops) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [balanceLeave, setBalanceLeave] = useState<EmployeeLeaveData>();
  const { loginObj } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
   const { hasPermission } = useAuth();
  
    useEffect(() => {
      if (!balanceLeave?.employeeId) return;
  
      const fetchAvatar = async () => {
        try {
          const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${balanceLeave?.employeeId}`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${loginObj?.token || ""}`,
            },
          });
  
          if (!res.ok) throw new Error("Avatar not found");
  
          const blob = await res.blob();
          if (blob.size > 0) {
            setAvatarUrl(URL.createObjectURL(blob));
          } else {
            setAvatarUrl(null);
          }
        } catch (err) {
          console.error("Error fetching avatar", err);
          setAvatarUrl(null); 
        }
      };
  
      fetchAvatar();
    }, [balanceLeave?.employeeId]);


  const loadDetailedBalanceLeave = async () => {
    const response = await fetchApi("Hrlense_Leave/employeeBalanceLeave", "GET", "", `employeeId=${props.selectedLeave?.employeeId}&includeDetails=true`, "");
    if (response) {
      setBalanceLeave(response);
    }
  };

  useEffect(() => {
    if (props.selectedLeave?.employeeId) loadDetailedBalanceLeave();
  }, [props.selectedLeave]);

  const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    addToast({ message: `${type} copied!`, status: 'success' });
  }
  return (
    <MyDiv>
      <Box className="card_wrapper ">
        <Box position="relative" h="140px">
          <Image src={BackgroundProfileImg} alt="Cover" w="100%" h="100%" objectFit="cover" />
        </Box>

        <Flex align="center" gap={4} px={5} mt={-10}>
          <Avatar src={avatarUrl ? avatarUrl : DummyPerson} size="xl" name="" />
          <Box w="100%" mt={12}>
            <Flex justifyContent="space-between" alignItems="center" width="100%">
              <Tooltip label={balanceLeave?.details?.name} placement="top" hasArrow>
              <Text className="font-poppins text_xl text_medium font_dark" maxWidth="9vw" isTruncated>
                {balanceLeave?.details?.name}
              </Text>
              </Tooltip>
              <Text color={balanceLeave?.details?.status === "Active" ? "#38A169" : "#E53E3E"} 
                bg={balanceLeave?.details?.status === "Active" ? "#F0FFF4" : "#FFF5F5"} className="font-poppins text_medium text_sm" maxWidth="5vw" > 
                {balanceLeave?.details?.status} 
              </Text>
            </Flex>

            <Flex gap={3} mt={2} alignItems="center" flexWrap="wrap">
              <Badge className="badgeId font-poppins text_medium">
                {balanceLeave?.details?.employeeCode}
                <Image  cursor="pointer" 
                src={CopyIcon}
                alt="Copy"
                ml={2}
                onClick={(e) => {
                  e.stopPropagation();
                  copyToClipboard(balanceLeave?.details?.employeeCode ?? "", "Employee ID"); 
                }}
                />
              </Badge>
              <Tooltip label={balanceLeave?.details?.designation_Name} placement="top" hasArrow>
              <Badge className="badgeDegi font-poppins text_sm text_medium" maxWidth="11vw" isTruncated>
                {balanceLeave?.details?.designation_Name}
              </Badge>
              </Tooltip>
              
            </Flex>
          </Box>
        </Flex>

        <Divider orientation="horizontal" mt={4} />

        <Box px={4} mt={4}>
          <Text className="font-poppins font_dark text_medium text_sm" mb="8px">Basic Information</Text>
          <Flex className="info_grid">
            <Flex align="center" gap={2}>
              <Image src={DepartmentFrame} />
              <Flex flexDirection="column">
                <Text fontSize="8px" color="rgba(0, 0, 0, 0.5)">Department</Text>
                <Text className="font-poppins font_dark text_medium text_sm">{balanceLeave?.details?.departmentName}</Text>
              </Flex>
            </Flex>
            <Flex align="center" gap={2}>
              <Image src={BranchFrame} />
              <Flex flexDirection="column">
                <Text fontSize="8px" color="rgba(0, 0, 0, 0.5)">Branch</Text>
                <Text className="font-poppins font_dark text_medium text_sm">{balanceLeave?.details?.branch_Name}</Text>
              </Flex>
            </Flex>
            <Flex align="center" gap={2}>
              <Image src={EmailFrame} />
              <Flex flexDirection="column">
                <Text fontSize="8px" color="rgba(0, 0, 0, 0.5)">Email</Text>
                <Tooltip label={balanceLeave?.details?.email} placement="top" hasArrow>
                <Text className="font-poppins font_dark text_medium text_sm" maxWidth="7vw" isTruncated>{balanceLeave?.details?.email}</Text>
                </Tooltip>
              </Flex>
            </Flex>
            <Flex align="center" gap={2}>
              <Image src={PhoneFrame} />
              <Flex flexDirection="column">
                <Text fontSize="8px" color="rgba(0, 0, 0, 0.5)">Phone</Text>
                <Text className="font-poppins font_dark text_medium text_sm">{balanceLeave?.details?.phone}</Text>
              </Flex>
            </Flex>
          </Flex>
        </Box>

        <Divider orientation="horizontal" mt={4} />

        <Box px={4} mt={4} mb={6}>
          <Text className='font-poppins text_medium text_sm' fontWeight="bold" fontSize="md" mb={4}>
            Leave Information
          </Text>

          <Box mb={2} bg="rgba(245, 245, 245, 1)" p={2} h="80px" borderRadius='lg'>
            <Text fontWeight="semibold" fontSize="sm" mb={1}>Casual Leave</Text>
            <Grid templateColumns="repeat(3, 2fr)" gap={10}>
              <Box bg="white" borderRadius="sm" minH="41px" w='91px'>
                <Text fontSize="xs" color="blue" ml={2}>Allocated</Text>
                <Text fontSize="sm" color="blue" ml={2}>{balanceLeave?.casualLeaveGiven ?? 0}</Text>
              </Box>
              <Box bg="white" minH="41px" w='68px'>
                <Text fontSize="xs" color="orange" ml={2}>Used</Text>
                <Text fontSize="sm" color="orange" ml={2}>
                  {Math.max(0, (balanceLeave?.casualLeaveGiven ?? 0) - (balanceLeave?.balance_CL ?? 0))}
                </Text>
              </Box>
              <Box bg="white" minH="40px">
                <Text fontSize="xs" color="green" ml={2}>Remaining</Text>
                <Text fontSize="sm" color="green" ml={2}>{balanceLeave?.balance_CL ?? 0}</Text>
              </Box>
            </Grid>
          </Box>

          <Box mb={2} bg="rgba(245, 245, 245, 1)" p={2} h="80px" borderRadius='lg'>
            <Text fontWeight="semibold" fontSize="sm" mb={1}>Earned Leave</Text>
            <Grid templateColumns="repeat(3, 2fr)" gap={10}>
              <Box bg="white" borderRadius="sm" minH="41px" w='91px'>
                <Text fontSize="xs" color="blue" ml={2}>Allocated</Text>
                <Text fontSize="sm" color="blue" ml={2}>{balanceLeave?.earnedLeaveGiven ?? 0}</Text>
              </Box>
              <Box bg="white" minH="41px" w='68px'>
                <Text fontSize="xs" color="orange" ml={2}>Used</Text>
                <Text fontSize="sm" color="orange" ml={2}>
                  {Math.max(0, (balanceLeave?.earnedLeaveGiven ?? 0) - (balanceLeave?.balance_EL ?? 0))}
                </Text>
              </Box>
              <Box bg="white" minH="40px">
                <Text fontSize="xs" color="green" ml={2}>Remaining</Text>
                <Text fontSize="sm" color="green" ml={2}>{balanceLeave?.balance_EL ?? 0}</Text>
              </Box>
            </Grid>
          </Box>
        </Box>

        {/* Button */}
         {hasPermission('LeavesBalance', 'Add_LeaveBalance') && (
           <Box justifyItems="end">
          <Button className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} alt="Edit" />} onClick={onOpen} >
            Add and update Leave Balance
          </Button>
        </Box>
         )}
       
      </Box>

      {/* Modal */}
      <Modal size='xl' isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className='font-poppins text_medium text_md' textAlign="center">
            Add and Update Leave balance
          </ModalHeader>
          <Divider orientation="horizontal" />
          <ModalCloseButton />
          <ModalBody>
            <LeaveBalanceModal onClose={onClose} employeeBalanaceLeave={balanceLeave} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </MyDiv>
  );
};

export default LeaveBalanceCard;
